// extracted by mini-css-extract-plugin
export default {"innerWrapper":"page_innerWrapper__wYPMf","header":"page_header__jeg2e","footer":"page_footer__MilrE"};